import { refreshTracks } from "../main-canvas/messages/post-track-messages.ts";
import { useGenomeViewerStore } from "../store/store.ts";
import type { CanvasCoordinate } from "../types.ts";
export const navigateToPosition = ({ x, y }: CanvasCoordinate) => {
  useGenomeViewerStore.setState({ scrollX: x, scrollY: y });
  refreshTracks();
};
